// LLM generated - Model Claude 4 Sonnet
export default {
  components: {
    sectionTabs: {
      entrantsTab: 'dt.entrants-manager.components.sectionTabs.entrantsTab',
      revivalsTab: 'dt.entrants-manager.components.sectionTabs.revivalsTab',
      activityTab: 'dt.entrants-manager.components.sectionTabs.activityTab',
    },
    emptyState: {
      noEntrants: 'dt.entrants-manager.components.emptyState.noEntrants',
    },
  },
};
